exports.onClientEntry = () => {
  const pathRoboto =
    'https://fonts.googleapis.com/css?family=Roboto:300,400,500,600,700,800|Quicksand:400,500';
  const linkRoboto = document.createElement('link');
  linkRoboto.setAttribute('rel', 'stylesheet');
  linkRoboto.setAttribute('href', pathRoboto);
  document.head.appendChild(linkRoboto);
};
